import { render, staticRenderFns } from "./G2Plot.vue?vue&type=template&id=46acc7a3&"
import script from "./G2Plot.vue?vue&type=script&lang=js&"
export * from "./G2Plot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports